<template>
  <b-modal
    ref="modal"
    :hide-footer="true"
    @hidden="closeModal"
    @show="resetModal"
  >
    <template v-slot:modal-title>
      {{ modalName }}
    </template>
    <b-form @submit.stop.prevent="onSubmit">
      <div
        v-for="(field,index) in fields"
        :key="index"
      >
        <b-form-group
          v-if="field.type === 'text'"
          :id="`input-group-${field.name}`"
          :label="field.label"
          :label-for="`input-${field.name}`"
        >
          <b-input
            :id="`input-${field.name}`"
            v-model="$v.form[field.name].$model"
            :type="field.type"
            :state="validateState(field.name)"
            :aria-describedby="`input-${field.name}-live-feedback`"
            :placeholder="field.placeholder"
          />
          <b-form-invalid-feedback :id="`input-${field.name}-live-feedback`">
            {{ field.validationError }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-checkbox
          v-if="field.type === 'checkbox' && ((field.editOnly && editMode) || !field.editOnly) "
          :id="`input-${field.name}`"
          v-model="$v.form[field.name].$model"
          size="md"
          class="flex-shrink-0 pt-2"
        >
          {{ field.label }}
        </b-form-checkbox>
        <b-form-checkbox
          v-if="field.type === 'callbackCheckbox' && ((field.createOnly && !editMode) || !field.createOnly)"
          :id="`input-${field.name}`"
          v-model="$v.form[field.name].$model"
          size="md"
          class="flex-shrink-0 pt-2"
        >
          {{ field.label }}
        </b-form-checkbox>
        <b-form-group
          v-if="field.type === 'multiselect'"
          :id="`input-group-${field.name}`"
          :label="field.label"
          :label-for="`input-${field.name}`"
        >
          <multiselect
            v-if="field.type === 'multiselect'"
            v-model="$v.form[field.name].$model"
            :placeholder="field.label"
            :options="field.values"
            :multiple="true"
            select-label="✓"
            deselect-label="✗"
            selected-label=""
          />
        </b-form-group>
      </div>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          type="submit"
          variant="primary"
        >
          Save
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
  import validateStateMixin from "../../mixins/validateStateMixin"
  import Multiselect from "vue-multiselect"

  export default {
    name: "BeCreateEditModal",
    components: {
      Multiselect
    },
    mixins: [validateStateMixin],
    props: ['modalName', 'fields', 'open', 'url', 'editMode', 'value'],
    data() {
      let data = {
        form: {}
      };
      for (let field of this.fields) {
        data.form[field.name] = this.editMode ? this.model[field.name] : ''
      }
      return data;
    },
    watch: {
      open: function () {
        if (this.open) {
          this.$refs['modal'].show()
        } else {
          this.$refs['modal'].hide()
        }
      }
    },
    created() {

    },
    methods: {
      async onSubmit(evt) {
        evt.preventDefault();
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          return;
        }

        try {
          let response;
          if (this.editMode) {
            response = await this.$http.put(`${this.url}/${this.value.id}`, this.form);
          } else {
            response = await this.$http.post(this.url, this.form);
          }
          const item = response.data;
          let callbackFields = this.fields.filter(f=>f.type === 'callbackCheckbox');
          for (const callbackField of callbackFields){
            if (this.form[callbackField.name]) {
              await callbackField.callback(item);
            }
          }
          this.closeModal()
        } catch (error) {
          this.handleErrorResponse(error);
        }
      },
      closeModal() {
        this.$emit('modal-closed')
      },
      resetModal() {
        for (let field of this.fields) {
          if (this.editMode) {
            this.form[field.name] = this.value[field.name];
            continue
          }
          switch (field.type) {
            case 'checkbox':
              this.form[field.name] = false;
              break;
            case 'callbackCheckbox':
              this.form[field.name] = false;
              break;
            default:
              this.form[field.name] = '';
              break;
          }
        }
        this.$v.$reset();
      }
    },
    validations() {
      let validations = {form: {}};
      for (let field of this.fields) {
        validations.form[field.name] = field.validations;
      }
      return validations;
    }
  }
</script>

<style lang="scss" scoped>
</style>